/* eslint-disable multiline-ternary */
/* eslint-disable no-unused-vars */
import { yupResolver } from "@hookform/resolvers/yup";
import { selectThemeColors } from "@utils";
import React, { Fragment, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as yup from "yup";
import { USER_ROUTES } from "../../../constant/route";
import { NELOption } from "../../apps/styleProfile/utils";
import { updateStyleProfileV2 } from "../../../services/styleProfileServices";
import { getCurrentUserService } from "../../../services/getCurrentUser";
import { getErrorMsg } from "../../../common/ErrorMessages/errorMessage";
import ToastContent from "../toast/toast";
import { Check } from "react-feather";
import toast from "react-hot-toast";
// import { getCountryData } from "../../../services/user.services";

const defaultValues = {
  most_used_nle: "",
  client_speaking_language: "",
  // country_id: "",
};

const StyleProfileModalV2 = () => {
  const [styleProfileModalV2State, setStyleProfileModalV2State] =
    useState(false);
  const [userData, setUserData] = useState();
  const [disabledButton, setDisabledButton] = useState(false);

  useEffect(() => {
    getCurrentUserService()
      .then((res) => {
        setUserData(res?.data?.style_profile);
        if (
          res?.data?.is_admin !== "1" &&
          res?.data?.style_profile !== null &&
          (res?.data?.style_profile?.most_used_nle === null ||
            res?.data?.style_profile?.client_speaking_language === null)
        ) {
          setStyleProfileModalV2State(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setStyleProfileModalV2State(false);
      });
  }, []);

  const navigate = useNavigate();
  const Schema = yup.object({
    most_used_nle: yup.string().required("NLE software is Required").nullable(),
    client_speaking_language: yup
      .string()
      .required("Language spoken by your client is Required")
      .max(
        15,
        "Language spoken by your client should not exceed 15 characters"
      ),
    // country_id: yup.string().required("Region is Required").nullable(),
  });

  const {
    control,
    setError,
    setValue,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(Schema) });

  // const [countryData, setCountryData] = useState();
  // useEffect(() => {
  //   getCountryData()
  //     .then((res) => {
  //       setCountryData(res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  const onSubmit = (data) => {
    const SendData = {
      user_id: userData?.user_id,
      most_used_nle: data.most_used_nle,
      client_speaking_language: data.client_speaking_language,
      // country_id: data.country_id,
    };
    setDisabledButton(true);
    updateStyleProfileV2(SendData)
      .then((res) => {
        setStyleProfileModalV2State(false);
        toast((t) => (
          <ToastContent
            t={t.id}
            message={res?.data?.message}
            icon={<Check size={12} />}
          />
        ));
      })
      .catch((err) => {
        setStyleProfileModalV2State(true);
        console.log(err);
        getErrorMsg(err);
      })
      .finally(() => {
        setDisabledButton(false);
      });
  };
  return (
    <Fragment>
      <Modal
        className="modal-dialog-centered modal-lg"
        centered
        isOpen={styleProfileModalV2State}
      >
        <ModalHeader>
          <h1 className="my-50">Plese fill in the following filds</h1>
        </ModalHeader>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <Row className="gy-1 pt-75">
              <Col md={12} xs={12}>
                <Label>What langage do your clients typically speak?</Label>
                <Controller
                  defaultValue=""
                  control={control}
                  id="client_speaking_language"
                  name="client_speaking_language"
                  render={({ field }) => (
                    <Input
                      type="text"
                      placeholder="What language do your clients typically speak?"
                      {...field}
                    />
                  )}
                />
                {errors.client_speaking_language && (
                  <FormFeedback>
                    {errors.client_speaking_language.message}
                  </FormFeedback>
                )}
              </Col>
              <Col md={12} xs={12} className="mb-1">
                <Label className="form-label" for="InputHelp">
                  Which NLE software do you use most? We currently only use
                  Premiere, but this information is helpful to us in planning
                  for the future so we can better serve you
                </Label>
                <Controller
                  id="most_used_nle"
                  name="most_used_nle"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={NELOption}
                      theme={selectThemeColors}
                      className="react-select"
                      classNamePrefix="select"
                      // placeholder="Codec"
                      value={NELOption.find(
                        (row) => row.value === watch("most_used_nle")
                      )}
                      onChange={(e) => {
                        setValue("most_used_nle", e.value);
                        if (e !== null) {
                          setError("most_used_nle", "");
                        }
                      }}
                    />
                  )}
                />
                {errors.most_used_nle && (
                  <FormFeedback>{errors.most_used_nle.message}</FormFeedback>
                )}
              </Col>
              {/* <Col xs="12" md="12">
                <div className="mb-1">
                  <Label className="form-label" for="country_id">
                    Region
                  </Label>
                  <Controller
                    id="country_id"
                    name="country_id"
                    control={control}
                    render={({ field }) => {
                      return (
                        <Select
                          {...field}
                          options={countryData}
                          theme={selectThemeColors}
                          className="react-select"
                          classNamePrefix="select"
                          value={
                            watch("country_id")
                              ? countryData?.find(
                                  (e) => e?.id === Number(watch("country_id"))
                                )
                              : null
                          }
                          getOptionValue={(opt) => opt.id}
                          getOptionLabel={(opt) => opt.country_name}
                          onChange={(e) => {
                            setValue("country_id", e.id);
                            if (e !== null) {
                              setError("country_id", "");
                            }
                          }}
                        />
                      );
                    }}
                  />
                  {errors.country_id && (
                    <FormFeedback>{errors.country_id.message}</FormFeedback>
                  )}
                </div>
              </Col> */}
            </Row>
          </ModalBody>
          <ModalFooter>
            {/* <Button
              color="primary"
              className=""
              onClick={() => navigate(USER_ROUTES.STYLE_PROFILE)}
            >
              Style Profile
            </Button> */}
            <Button
              color="primary"
              className="d-none"
              onClick={() => setStyleProfileModalV2State(false)}
            >
              Close
            </Button>
            <Button
              disabled={disabledButton}
              type="submit"
              className="me-1"
              color="primary"
              //   onClick={() => navigate(USER_ROUTES.STYLE_PROFILE)}
            >
              Submit
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default StyleProfileModalV2;
